import type { AxiosInstance } from "axios";

export class KillbillService {
  private api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this.api = api;
  }

  async getPurchasePlans(url:string): Promise<any[]> {
    try {
      const resp = await this.api.get<any[]>(
        url
      );
      return (resp as any)?.data ?? [];
    } catch (error: any) {
      console.error("[KillbillService] Error al obtener planes de compra", error);
      throw error;
    }
  }
  async createSubscription(planName: string,url:string): Promise<any> {
    try {
      const resp = await this.api.post<any>(
        url,
        { planName }
      );
      return (resp as any)?.data ?? null;
    } catch (error: any) {
      console.error("[KillbillService] Error al crear suscripción", error);
      throw error;
    }
  }
}
